// Bridge: the vendored tpo screens resolve their hooks inside src/tpo, but the
// submissions endpoints themselves are lendmarq-los's own — one hook, one axios
// client, one auth token. See src/tpo/README.md.
import { useBorrowerSubmissionsHook } from "../../hooks/useBorrowerSubmissionsHook";

export { useBorrowerSubmissionsHook };
export default useBorrowerSubmissionsHook;
